import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Alert } from '@surfline/quiver-react';
import { toggleRegistrationForm } from '../../redux/actions/interactions';
import { trackEvent, navigatedToPage } from '../../redux/actions/segmentEvents';
import { validateCode, confirmRedemption, reset } from '../../redux/actions/redeem';
import { getAccessToken } from '../../selectors/auth';
import { RegistrationWrapper } from '../../containers';
import {
  GiftRailCTA,
  MobileGiftRailCTA,
  LeftRail,
  RightRail,
  GiftRedeemHeader,
  RegistrationSubtitle,
  FacebookLogin,
  RedeemForm,
  RedeemConfirmation,
  RedeemError,
} from '../../components';
import en from '../../international/translations/en';
import config from '../../config';

class Redeem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      registrationRendered: false,
      redeemRendered: false,
    };
    this.props.doNavigatedToPage('Funnel', 'Redeem', {}, { Wootric: false });
  }

  viewedRedeem = () => {
    if (!this.state.redeemRendered) {
      this.setState({ redeemRendered: true });
      this.props.doTrackEvent('Viewed Redeem Step', { step: 2 });
    }
  }

  viewedRegistration = () => {
    if (!this.state.registrationRendered) {
      this.setState({ registrationRendered: true });
      this.props.doTrackEvent('Viewed Redeem Step', { step: 1 });
    }
  }

  renderRedeemConfirmation = () => {
    const {
      validationErrorCode,
      giftProduct,
      subscription,
      code,
      doConfirmRedemption,
      doResetRedeem,
      submitting,
      redeemSuccess
    } = this.props;
    if (validationErrorCode) {
      return (
        <RedeemError
          validationErrorCode={validationErrorCode}
          doResetRedeem={doResetRedeem}
        />
      );
    }

    return (
      <div>
        <RedeemConfirmation
          giftProduct={giftProduct}
          subscription={subscription}
          code={code}
          doConfirmRedemption={doConfirmRedemption}
          submitting={submitting}
          redeemSuccess={redeemSuccess}
        />
      </div>
    );
  }

  renderRedeemForm = () => {
    const {
      doValidateCode,
      submitting,
    } = this.props;
    return (
      <div>
        <GiftRedeemHeader />
        <RedeemForm
          submitHandler={doValidateCode}
          submitting={submitting}
        />
      </div>
    );
  }

  renderRegistrationForm = () => {
    const {
      showLogin,
      doToggleForm,
    } = this.props;
    return (
      <RegistrationWrapper
        showLogin={showLogin}
        formLocation="redeem"
        viewedRegistration={this.viewedRegistration}
      >
        <GiftRedeemHeader
          hideSubtitle
          showLogin={showLogin}
        >
          <RegistrationSubtitle showLogin={showLogin} doToggleForm={doToggleForm} />
        </GiftRedeemHeader>
        <FacebookLogin
          formLocation="redeem"
        />
      </RegistrationWrapper>
    );
  }

  render() {
    const {
      accessToken,
      giftProduct,
      validationError,
      validationErrorCode,
    } = this.props;
    let ctaCopy = {
      ...en.giftCards,
    };
    const { funnelConfig } = config;
    if (funnelConfig) {
      ctaCopy = {
        backgroundImage: `url(${funnelConfig.bgDesktopImgPath})`,
        layeredCardImage: `url(${funnelConfig.layeredCardImgPath})`,
        rightRailHeader: funnelConfig.detailCopy
      };
    }
    return (
      <div>
        <div className="redeem-funnel">
          <MobileGiftRailCTA ctaCopy={ctaCopy} funnelConfig={!!funnelConfig} />
          <LeftRail>
            <div className="redeem-funnel__content">
              {validationError ? (
                <Alert type="error">
                  {validationError}
                </Alert>
              ) : null}
              {giftProduct || validationErrorCode ? (
                this.renderRedeemConfirmation()
              ) : (
                <div>
                  {accessToken ? (
                    this.renderRedeemForm()
                  ) : (
                    this.renderRegistrationForm()
                  )}
                </div>
              )}
            </div>
          </LeftRail>
          <RightRail>
            <GiftRailCTA ctaCopy={ctaCopy} />
          </RightRail>
        </div>
      </div>
    );
  }
}

Redeem.propTypes = {
  accessToken: PropTypes.string,
  showLogin: PropTypes.bool,
  submitting: PropTypes.bool,
  validationError: PropTypes.string,
  validationErrorCode: PropTypes.number,
  giftProduct: PropTypes.shape({}),
  subscription: PropTypes.shape({}),
  code: PropTypes.string,
  redeemSuccess: PropTypes.bool,
};

Redeem.defaultProps = {
  accessToken: null,
  showLogin: false,
  submitting: false,
  validationError: null,
  validationErrorCode: null,
  giftProduct: null,
  subscription: null,
  code: null,
  redeemSuccess: false,
};

export default connect(
  state => ({
    accessToken: getAccessToken(state),
    showLogin: state.interactions.showLogin,
    submitting: state.interactions.submitting,
    validationError: state.redeem.validationError,
    validationErrorCode: state.redeem.validationErrorCode,
    giftProduct: state.redeem.giftProduct,
    subscription: state.redeem.subscription,
    code: state.redeem.code,
    redeemSuccess: state.redeem.redeemSuccess,
  }),
  dispatch => ({
    doToggleForm: showLogin => dispatch(toggleRegistrationForm(showLogin, 'redeem')),
    doTrackEvent: (name, properties) => dispatch(trackEvent(name, properties)),
    doNavigatedToPage: (name, category, properties, integrations) =>
      dispatch(navigatedToPage(name, category, properties, integrations)),
    doValidateCode: code => dispatch(validateCode(code)),
    doConfirmRedemption: code => dispatch(confirmRedemption(code)),
    doResetRedeem: () => dispatch(reset()),
  }),
)(Redeem);
